import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import RCMStatusPageComponent from "./RCMStatusPage";
import { createSelector } from 'reselect';
import { createStringDataField,createCurrencyDataField } from '../../util/format';

export const RCMStatusPage = connect(
    () => {

        const selectLineItemOverPaidAndUnderpaidFields:any = createSelector(
            () => [
                createStringDataField('contractName', 'Contract Name', { sortable: true,hideFromFilter:true }),
                createStringDataField('volume', 'Volume', { sortable: true,hideFromFilter:false}),
                createCurrencyDataField('variance', 'Variance', { sortable: true,hideFromFilter:false,calculateTotal:true}),
            ]
        );

        const selectTotalVarianceFields:any = createSelector(
            () => [
                createStringDataField('type', 'Type', { sortable: true,hideFromFilter:true }),
                createStringDataField('volume', 'Volume', { sortable: true,hideFromFilter:false}),
                createCurrencyDataField('variance', 'Variance', { sortable: true,hideFromFilter:false,calculateTotal:true}),
            ]
        );

        const selectZeroPaymentFields:any = createSelector(
            () => [
                createStringDataField('contractName', 'Contract Name', { sortable: true,hideFromFilter:true }),
                createStringDataField('denialCode', 'Denial Code', { sortable: true,hideFromFilter:false}),
                createStringDataField('grouping', 'Grouping', { sortable: true,hideFromFilter:false, onHover: true}),
                createStringDataField('volume', 'Volume', { sortable: true,hideFromFilter:false}),
                createCurrencyDataField('variance', 'Variance', { sortable: true,hideFromFilter:false,calculateTotal:true}),

            ]
        );
      

        return (state, props) => ({
            lineItemsOverPaidAndUnderpaidFields:selectLineItemOverPaidAndUnderpaidFields(state),
            totalVarianceFields:selectTotalVarianceFields(state),
            zeroPaymentFields:selectZeroPaymentFields(state)

        });
    },
    (dispatch) => ({
        actions: bindActionCreators({

        }, dispatch)
    })
)(injectIntl(RCMStatusPageComponent));